import { Card } from "antd";
import "../../styles/doctorCard.scss";
import { $host } from "../../http/index";

const DoctorCard = ({ doctor }) => {
  const language = localStorage.getItem("lang")?localStorage.getItem("lang"):'am'
  const firstNameKey = `firstName${language.toUpperCase()}`;
  const lastNameKey = `lastName${language.toUpperCase()}`;
  const position = `position${language.toUpperCase()}`;
  return (
    <Card className="doctor-card" hoverable>
      <img
        src={
          $host.defaults.baseURL +
          'photos/doctors/' +
          (doctor.img_main ? doctor.img_main : 'docdefault.jpg')
        }
        alt={`${doctor[firstNameKey]} ${doctor[lastNameKey]}`} className="doctor-image" />
      <div className="doctor-info">
        <h3>{doctor[firstNameKey]} {doctor[lastNameKey]}</h3>
        <p>{doctor[position]}</p>
        {/* <p className="doctor-title">{doctor.cabinet}</p> */}
        {/* <p className="doctor-phone">{doctor.phone}</p> */}
      </div>
    </Card>
  );
};

export default DoctorCard;
